// 实时视频与操作的 mediasoup文件
import { Device } from 'mediasoup-client'
import { WebSocketTransport, Peer } from 'protoo-client'
import { CHAT, ACION_REQUEST, websocketapp, setHandleHelmetOperationResponse } from '@/common/websocket/index'
import { warning, confirmWin, alertWin } from '@/util/common'
import store from '@/store/index'
import { mediasSaveCode, apiMedia } from '@/api/log/video'
import { signCode } from '@/api/config'
import md5 from 'js-md5'
import { getSession } from '@/api/common'
import i18n from '@/common/i18n'
import $ from 'jquery'
import { set } from 'lodash'

var rtmpUrl = ''
var code = ''

let roomPeers
/**
 * 声音关闭
 */
const VOLUME_OFF = 0
/**
 * 声音开启
 */
const VOLUME_ON = 1

// websocket 是否连接成功
let g_is_login = false

let _closed = false

// Display name.
// @type {String}
let _peerId = 'web' + uuid()

let _peerName = '管理员' + randomNumstr(4)

//当前所有peers
let _peers = {}

// Device info.
// @type {Object}
let _device = {}

// Whether we want to force RTC over TCP.
// @type {Boolean}
let _forceTcp = false

// protoo-client Peer instance.
// @type {protooClient.Peer}
let _peer = null

// mediasoup-client Device instance.
// @type {mediasoupClient.Device}
let _mediasoupDevice = null

// mediasoup Consumers.
// @type {Map<String, mediasoupClient.Consumer>}
let _consumers = new Map()

// Local mic mediasoup Producer.
// @type {mediasoupClient.Producer}
let _micProducer = null

// 当前的房间号
let roomId = null

//房间是否在进行中
var g_is_meeting = false
// 已经消费的producerId
var consumeredProduIds = new Set()

// 是否有麦克风设备
let hasMic = false

var clearTime

//最后一次关闭时间
let closeTime = null

// 录像rtmp 地址
var rtmpPrefix = null

var showVoice = false

// 观看头盔是否在房间内
var enterRoom = false

var is_leave = false //判断是否是因为加入已有会议发生的离开原有会议动作

var meetLiveCode = ''

/**
 * 当前用户信息
 */
let current = {
  helmetId: null,
  resolutionP: null,
  userId: null,
  userName: null,
}
/**
 * 安全帽掉线处理逻辑
 * @param {String} peerId 房间用户id，安全帽的格式为ms_userid，例如ms_288
 */
let handleHelmetLeave = function(peerId) {
  // leaveRoomSelf()
}

/**
 * 外部设置 安全帽掉线处理逻辑
 * @param {Function} callback 安全帽掉线处理逻辑
 */
function setHandleHelmetLeave(callback) {
  handleHelmetLeave = callback
}

let resolvingPower = function() {}

function setresolvingPower(callback) {
  resolvingPower = callback
}

/**
 * websocket与视频平台建立连接
 */
async function loginMVCPUtil() {
  await checkMic()
  let url = store.getters.mediasoupWsUrl
  // console.log(url, url + '?peerId=' + _peerId + '&peerName=' + _peerName)
  var transport = new WebSocketTransport(url + '?peerId=' + _peerId + '&peerName=' + _peerName)
  _peer = new Peer(transport)
  _peer.on('open', () => {
    getRooms()
  })

  // failed、disconnected将触发重连事件，重连10次，不成功则触发close事件
  _peer.on('failed', () => {
    g_is_login = false
    console.error('MVCP websocket 连接失败！', g_is_login)
  })

  // 监听服务端发送的请求
  _peer.on('request', async (request, accept) => {
    console.debug('proto "request" event [method:%s, data:%o]', request.method, request.data)

    switch (request.method) {
      // 断线(被占用)
      case 'peerClose': {
        // warning('该账号已从另一设备登陆')
        _peer.close()
        break
      }
      // 接收到自定义消息
      case 'routerMsg': {
        const routerMsg = request.data
        if (routerMsg.cmd) {
          console.error('unknown protoo routerMsg.cmd "%s"', routerMsg.cmd)
        }
        accept()
        break
      }
      default: {
        console.error('unknown protoo request.method "%s"', request.method)
      }
    }
  })

  //通知
  _peer.on('notification', notification => {
    //NOSONAR
    switch (notification.method) {
      // 生产者分数
      case 'producerScore': {
        break
      }
      // 有新的消费者
      case 'newConsumer': {
        try {
          // 处理新消费者
          getRoomPeers()
        } catch (error) {
          console.error('"newConsumer" request failed:%o', error)
          throw error
        }
        break
      }
      // 新用户加入房间
      case 'roomPeerJoin': {
        break
      }
      // 用户离开房间
      case 'roomPeerLeave': {
        getRoomPeers()
        //延时5秒判断安全帽是否不再重连
        clearTime = setTimeout(function() {
          const { peerId } = notification.data
          var inRoomFlag = false
          //如果安全帽在当前会议中，则标记为true
          roomPeers.roomPeers.forEach(function(peer) {
            if (peer.id === peerId) {
              inRoomFlag = true
              return
            }
          })
          if (!inRoomFlag) {
            //如果安全帽主动离开房间且等于当前观看的用户id，则自动关闭视频框，并提示该安全帽已掉线
            if (
              peerId.indexOf('ms_') === 0 &&
              document.getElementById('mvcpVideo').srcObject != null &&
              'ms_' + current.userId === peerId
            ) {
              alertWin(i18n.t('hasBeenDisconnected'), handleHelmetLeave)
              leaveRoomSelf()
            }
          }
        }, 10000)
        break
      }
      // 修改用户名
      case 'peerNameChanged': {
        break
      }
      // 下行带宽评估的通知
      case 'downlinkBwe': {
        break
      }
      // 消费者关闭（生产者关闭）
      case 'consumerClosed': {
        const { consumerId } = notification.data
        const consumer = _consumers.get(consumerId)
        if (!consumer) break
        // 关闭
        consumer.close()
        // 从消费者列表删除
        _consumers.delete(consumerId)
        break
      }
      // 消费者暂停消费（生产者暂停）
      case 'consumerPaused': {
        const { consumerId } = notification.data
        const consumer = _consumers.get(consumerId)
        if (!consumer) break
        consumer.pause()
        break
      }
      // 消费者恢复消费
      case 'consumerResumed': {
        const { consumerId } = notification.data
        const consumer = _consumers.get(consumerId)
        if (!consumer) break
        consumer.resume()
        break
      }
      // 消费者（视频）层级变更的通知（需开启simulcast）
      case 'consumerLayersChanged': {
        const { consumerId } = notification.data
        const consumer = _consumers.get(consumerId)
        if (!consumer) break
        break
      }
      // 消费者分数
      case 'consumerScore': {
        break
      }
      // 会议当前发言人
      case 'activeSpeaker': {
        // 正常 'activeSpeaker'不回执行
        break
      }
      default: {
        console.error('unknown protoo notification.method "%s"', notification.method)
      }
    }
  })
  _peer.on('response', response => {})
}
function loginClose() {
  if (_peers) {
    _consumers.forEach(function(consu) {
      consu.close()
    })

    _consumers.clear()
    consumeredProduIds.clear()
    _micProducer = null
    if (_peer) _peer.close()
  }
}

/**
 * 获取在线房间信息
 */
async function getRooms() {
  try {
    roomId = ((Math.floor(Math.random() * 10000) % 7) + 1).toString()
    for (var i = 0; i < 6; i++) {
      roomId = roomId + (Math.floor(Math.random() * 10000) % 8).toString()
    }
    console.log('生成房间号:', roomId)
    const { rooms } = await _peer.request('getRooms')
    for (var j = 0; j < rooms.length; j++) {
      if (roomId === rooms[j].id) {
        // 如果房间号重复，则重新生成房间号
        roomId = ((Math.floor(Math.random() * 10000) % 7) + 1).toString()
        for (var k = 0; k < 6; k++) roomId = roomId + (Math.floor(Math.random() * 10000) % 8).toString()
      }
    }
    g_is_login = true
  } catch (error) {
    if (error === 'transport closed') {
      alertWin(i18n.t('onlineRoomInformation'), handleHelmetLeave)
    }
    console.error('获取在线房间信息异常' + error)
  }
}
/**
 * 获取rtmp服务地址
 */
if (getSession('access_token')) {
  setTimeout(() => {
    rtmpPrefix = 'rtmp://192.168.3.121:1935'
  })
}

async function bindCamera(roomId) {
  let contents =
    '{"override":true,"busName":"meet' +
    roomId +
    '","busCode":"meet' +
    roomId +
    '","mediaType":0,"outFlv":true,"saveVideo":true}'

  const reqCode = randomString(8)
  const reqTime = new Date()
    .getTime()
    .toString()
    .substr(0, 10)
  const sign = md5(signCode.token + reqCode + reqTime + contents + signCode.accessCode)
  // 在请求头需要加密处理，不然会直接401
  const token = signCode.token
  await apiMedia(contents, token, reqCode, reqTime, sign).then(res => {
    //如果返回值格式错误则返回null
    if (res !== null && res.data) {
      const rtmp = res.data.urlData.rtmp
      code = res.data.code
      if (rtmp !== null) {
        //拼接rtmp地址
        rtmpUrl = 'rtmp://' + res.data.serverIp + ':' + res.data.serverPortMap.rtmp + rtmp
      }
    }
  })
  return { code: code, rtmpUrl: rtmpUrl }
}
// 生成随机字符串
function randomString(length) {
  const str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let result = ''
  for (let i = length; i > 0; --i) result += str[Math.floor(Math.random() * str.length)]
  return result
}

function saveLiveCode(code) {
  let helmetLiveCode = {
    helmetId: current.helmetId,
    userId: current.userId,
    meetId: roomId,
    userName: current.userName,
    liveCode: code,
    recordType: 0,
    groupActual: meetLiveCode,
  }
  //如果code不为空则保存到后台
  if (code !== '') {
    mediasSaveCode(helmetLiveCode).then(res => {})
  }
}

/**
 * 加入房间
 * @param {String} roomId 房间号
 */
async function _joinRoom(roomId, liveObj) {
  console.log(`加入房间:${roomId}`)

  // leaveRoomSelf()
  if (!_peer._connected && !_closed && getSession('access_token')) {
    // 易造成发送两条join请求
    loginMVCPUtil()
    setTimeout(() => {
      _joinRoom(roomId, liveObj)
    }, 3000)
  } else {
    _device = getBrowserInfo()
    // 加入房间
    await _peer.request('join', {
      roomId: roomId,
      device: _device,
      rtmpUrl: liveObj === undefined ? '' : liveObj.rtmpUrl,
    })
    var code = liveObj === undefined ? '' : liveObj.code
    if (code) {
      setTimeout(() => {
        saveLiveCode(code)
      }, 1000)
    }
    g_is_meeting = true
    _mediasoupDevice = new Device()

    _closed = false
    // 获取router编解码能力
    const routerRtpCapabilities = await _peer.request('getRouterRtpCapabilities')

    // 使用mediasoup路由器的RTP功能加载设备。这就是设备如何知道允许的媒体编解码器和其他设置
    await _mediasoupDevice.load({ routerRtpCapabilities })

    // 创建媒体生产者
    await _produceMedia()

    if (store.state.helpVideo) {
      unmuteMic()
      localMdiasoupUnmuteMic()
    }
  }
}

let _sendTransport

let _recvTransport
// 创建媒体生产者
async function _produceMedia() {
  //NOSONAR
  try {
    // 服务器创建transport
    const transportInfo = await _peer.request('createWebRtcTransport', {
      forceTcp: _forceTcp,
    })
    const { id, iceParameters, iceCandidates, dtlsParameters } = transportInfo
    // 本地创建sendTransport
    _sendTransport = _mediasoupDevice.createSendTransport({
      id,
      iceParameters,
      iceCandidates,
      dtlsParameters,
      iceServers: [],
      proprietaryConstraints: {
        optional: [{ googDscp: true }],
      },
    })
    // console.log('测试_sendTransport',_sendTransport)
    // 监听connect，当produce调用时连接
    _sendTransport.on(
      'connect',
      (
        { dtlsParameters },
        callback,
        errback // eslint-disable-line no-shadow
      ) => {
        console.log('生产者')
        _peer
          .request('connectWebRtcTransport', {
            transportId: _sendTransport.id,
            dtlsParameters,
          })
          .then(callback)
          .catch(errback)
      }
    )

    // 监听produce，得到id，用于创建本地producer
    _sendTransport.on('produce', ({ kind, rtpParameters }, callback, errback) => {
      try {
        // eslint-disable-next-line no-shadow
        const { id } = _peer.request('produce', {
          transportId: _sendTransport.id,
          kind,
          rtpParameters,
        })

        callback({ id })
      } catch (error) {
        errback(error)
      }
    })

    _sendTransport.on('connectionstatechange', connectionState => {
      try {
        if (connectionState === 'disconnected') {
          if (_sendTransport && !is_leave) {
            _sendTransport.close()
          } else if (_sendTransport && is_leave) {
            is_leave = false
          }
          if (_recvTransport) _recvTransport.close()
        }
      } catch (error) {
        console.error('连接已断开，请重新连接')
      }
    })

    // 开启麦克风
    await enableMic()
    console.log(store.state.helpVideo, showVoice, ' 默认静音')
    // 默认静音
    if (!showVoice) {
      muteMic()
      localMiasoupMuteMic()
    }
  } catch (error) {
    console.error('发送音视频失败', error)
  }
}

// 创建媒体消费者
async function _consumeMedia() {
  try {
    // 服务端创建transport
    const transportInfo = await _peer.request('createWebRtcTransport', {
      forceTcp: _forceTcp,
    })

    const { id, iceParameters, iceCandidates, dtlsParameters } = transportInfo

    // 客户端创建recvTransport
    _recvTransport = _mediasoupDevice.createRecvTransport({
      id,
      iceParameters,
      iceCandidates,
      dtlsParameters,
      iceServers: [],
    })

    // 调用consume时connect
    _recvTransport.on('connect', ({ dtlsParameters }, callback, errback) => {
      console.log('消费者')
      _peer
        .request('connectWebRtcTransport', {
          transportId: _recvTransport.id,
          dtlsParameters,
        })
        .then(callback)
        .catch(errback)
    })
    _recvTransport.on('connectionstatechange', connectionState => {
      try {
        if (connectionState === 'disconnected') {
          // Close mediasoup Transports.
          if (_sendTransport) _sendTransport.close()

          if (_recvTransport) _recvTransport.close()
        }
      } catch (error) {
        console.error('连接已断开，请重新连接:transport disconnected %o', error)
      }
    })
  } catch (error) {
    console.error('订阅音视频失败:_consumeMedia failed:%o', error)
  }
}

// 订阅流
async function _getConsume(peerId, _producerId) {
  try {
    // 服务端订阅流
    let consume = await _peer.request('consume', {
      transportId: _recvTransport.id,
      peerId,
      producerId: _producerId,
      rtpParameters: _mediasoupDevice.rtpCapabilities,
    })
    const { id, kind, producerId, producerPaused, rtpParameters } = consume
    // 只订阅当前观看设备的流
    if (peerId.indexOf('web') === -1 && !consumeredProduIds.has(_producerId)) {
      // 本地订阅流
      _transportConsume({
        peerId: peerId,
        producerId,
        id,
        kind,
        producerPaused,
        rtpParameters,
      })
      consumeredProduIds.add(_producerId)
    }
  } catch (error) {
    console.error('订阅音视频流失败', error)
  }
}

// 本地订阅流
async function _transportConsume({ peerId, producerId, id, kind, type, producerPaused, rtpParameters }) {
  const consumer = await _recvTransport.consume({
    id,
    producerId,
    kind,
    rtpParameters,
  })
  _consumers.set(consumer.id, consumer)
  consumer.on('transportclose', () => {
    _consumers.delete(consumer.id)
  })
  // 根据webrtc-svc中的规则解析给定的scalabilityMode字符串。
  // const { spatialLayers, temporalLayers } = parseScalabilityMode(consumer.rtpParameters.encodings[0].scalabilityMode)
  console.log('consumer.track', consumer.track)
  if (consumer.track.kind === 'video') {
    var videoElm = document.getElementById('mvcpVideo')
    const { track } = consumer
    if (videoElm) {
      console.log(videoElm.srcObject)
      if (!videoElm.srcObject) {
        videoElm.srcObject = new MediaStream([track])
      } else {
        if (!videoElm.srcObject.active) {
          videoElm.srcObject = new MediaStream([track])
        }
      }

      videoElm.srcObject.oninactive = function() {
        offActive()
      }
    }
    console.log('加载视频流：' + consumer.track.id)
  }
  if (consumer.track.kind === 'audio') {
    var audioElm = document.getElementById('mvcpAudio')
    const stream = new MediaStream()
    console.log('加载音频流：' + consumer.track.id)
    stream.addTrack(consumer.track)
    audioElm.srcObject = stream
  }
}
// 黑屏处理
function offActive() {
  onactive()

  var videoOff = document.getElementById('mvcpVideo')
  // 显示加载页面
  // 15秒后查询头盔是否在线
  if (!videoOff) {
    return
  }
}
// 黑屏后监听流是否已恢复正常
function onactive() {
  var videoactive = document.getElementById('mvcpVideo')
  setTimeout(function() {
    if (videoactive && videoactive.srcObject) {
      console.log('active=' + videoactive.srcObject.active)
      if (!videoactive.srcObject.active) {
        $('#falseLoad').css('visibility', 'visible')
        onactive()
      } else {
        $('#falseLoad').css('visibility', 'hidden')
      }
    }
  }, 500)
}
// 开启麦克风
async function enableMic() {
  console.log('开启麦克风')
  if (_micProducer) return

  //判断后台是否有麦克风，若没有，则直接返回
  if (!hasMic) {
    warning('该网页已禁止使用麦克风')
    checkMic()
    return
  }

  if (!_mediasoupDevice.canProduce('audio')) {
    console.error('enableMic() | cannot produce audio')
    return
  }

  let track
  try {
    // 获取音频流
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
    track = stream.getAudioTracks()[0]
    // 创建producer
    _micProducer = await _sendTransport.produce({
      track,
      codecOptions: {
        opusStereo: 1,
        opusDtx: 1,
      },
    })
    _micProducer.on('transportclose', () => {
      _micProducer = null
    })

    _micProducer.on('trackended', () => {
      console.error('麦克风断开连接!')
      // 关闭producer
      disableMic().catch(() => {})
    })
  } catch (error) {
    console.error('enableMic() | failed:%o', error)
    if (track) track.stop()
  }
}

// 关闭麦克风
async function disableMic() {
  console.debug('disableMic()')

  if (!_micProducer) return

  // 本地关闭
  _micProducer.close()

  try {
    // 服务器关闭
    await _peer.request('closeProducer', {
      producerId: _micProducer.id,
    })
  } catch (e) {
    console.log(e)
  }

  _micProducer = null
}

/**
 * 远端流静音（暂停生产流）
 */
async function muteMic(voice) {
  if (voice) {
    showVoice = voice
  }
  try {
    let mvcpAudio = document.getElementById('mvcpAudio')
    if (mvcpAudio) {
      mvcpAudio.pause()
    }
  } catch (error) {
    console.error('静音异常', error)
  }
}

/**
 * 远端流解除静音（恢复生产流）
 */
async function unmuteMic(voice) {
  if (voice) {
    showVoice = voice
  }
  try {
    let mvcpAudio = document.getElementById('mvcpAudio')
    if (mvcpAudio) {
      mvcpAudio.play()
    }
  } catch (error) {
    console.error('取消静音异常', error)
  }
}

/**
 * 本地流静音
 */
async function localMiasoupMuteMic() {
  if (!_micProducer) {
    return
  }
  _micProducer.pause()
  try {
    console.log('_micProducer end', _micProducer)
    if (_micProducer.id) {
      await _peer.request('pauseProducer', {
        producerId: _micProducer.id,
      })
    }
  } catch (error) {
    console.error('静音异常', error)
  }
}

/**
 * 本地流解除静音
 */
async function localMdiasoupUnmuteMic() {
  if (!_micProducer) {
    return
  }
  _micProducer.resume()
  try {
    if (_micProducer.id) {
      await _peer.request('resumeProducer', {
        producerId: _micProducer.id,
      })
    }
  } catch (error) {
    console.error('取消静音异常', error)
  }
}
async function getMedia(peerId, producerId) {
  await _consumeMedia()
  _getConsume(peerId, producerId)
}
/**
 * 获取房间用户信息
 */
async function getRoomPeers() {
  if (!_sendTransport) {
    return
  }
  try {
    roomPeers = await _peer.request('getRoomPeers')
    console.debug(`roomPeers:${JSON.stringify(roomPeers)}`)
    console.log('roomPeers.roomPeers:', roomPeers.roomPeers)
    await _consumeMedia()
    setTimeout(() => {
      for (const roomPeer of roomPeers.roomPeers) {
        if (roomPeer.id !== _peerId) {
          // 获取房间用户生产者
          const { producers } = roomPeer
          producers.forEach(producer => {
            // 为每个生产者创建消费通道
            if (roomPeer.id.indexOf('web') !== 0) {
              _getConsume(roomPeer.id, producer.id)
            }
          })
        }
      }
    }, 1000)
  } catch (error) {
    // warning('获取房间用户信息失败，请关闭重新打开')
    console.error('获取房间用户信息失败:' + error)
  }
}

/**
 * 获取所有在线用户
 */
async function getPeers() {
  try {
    const { peers } = await _peer.request('getPeers')
    _peers = peers
  } catch (error) {
    console.error('获取在线用户失败', error)
  }
}

/**
 * 离开房间
 */
async function leaveRoomSelf(data) {
  if (document.getElementById('mvcpVideo')) {
    document.getElementById('mvcpVideo').srcObject = null
  }
  await _peer.request('leave')
  clearTimeout(clearTime)
  g_is_meeting = false
  if (!data) {
    roomId = ((Math.floor(Math.random() * 10000) % 7) + 1).toString()
    for (var i = 0; i < 6; i++) roomId = roomId + (Math.floor(Math.random() * 10000) % 8).toString()
  }
}

/**
 * 检查是否是否有麦克风，若没有，则直接返回
 */
async function checkMic() {
  try {
    await navigator.mediaDevices.getUserMedia({ audio: true })
    hasMic = true
  } catch (error) {
    if (error.message === 'Requested device not found') {
      console.error('您的计算机未找到麦克风设备')
    } else {
      console.error('checkMic error', error)
    }
    hasMic = false
  }
}

/**
 * 工具代码类
 */

//生成随机peerId
function uuid() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  )
}

// 生成随机数字符串
function randomNumstr(length) {
  if (typeof length != 'number') {
    length = 4
  }
  var numStr = ''
  for (var i = 0; i < length; i++) {
    numStr += Math.floor(Math.random() * 10)
  }
  return numStr
}

/**
 * 获取浏览器信息
 * @returns 例如：{flag: "chrome", name: "Chrome", version: "80.0.3987.132"}
 */
function getBrowserInfo() {
  var Sys = {}
  var ua = navigator.userAgent.toLowerCase()
  var re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/
  var m = ua.match(re)
  Sys.flag = m[1].replace(/version/, "'safari")
  Sys.name = Sys.flag[0].toUpperCase() + Sys.flag.substr(1)
  Sys.version = m[2]
  return Sys
}

/**
 * 业务代码
 */
if (
  getSession('access_token') &&
  store.getters.rtcType === 'mediasoup' &&
  !window.location.href.includes('Intercom') &&
  !window.location.href.includes('realvideo') &&
  !window.location.href.includes('/externalHistory')
) {
  loginMVCPUtil()
}

function refleshJoin(muted) {
  // 刷新
  helmetJoinMeet(current.helmetId, current.resolutionP, current.userId, current.userName, muted)
}

/**
 * 加入视频会议
 * @param {*} helmetId 安全帽序列号
 * @param {*} resolutionP 清晰度
 * @param {*} userId 用户id
 * @param {*} userName 用户名
 */
async function helmetJoinMeet(helmetId, resolutionP, userId, userName, isReflash) {
  // 记录当前会议人员信息
  current = {
    helmetId,
    resolutionP,
    userId,
    userName,
  }
  if (isReflash) {
    showVoice = true
  } else {
    showVoice = false
  }
  enterRoom = false
  $('#falseLoad').css('visibility', 'hidden')
  await getPeers()
  if (new Date() - closeTime > 5000) {
    console.log('未延时哦', _peers)
    noticeHelmetMeet(helmetId, resolutionP)
  } else {
    console.log('延时了')
    setTimeout(() => {
      noticeHelmetMeet(helmetId, resolutionP)
    }, 5000)
  }
}
var closeJoinMeet = null
async function noticeHelmetMeet(helmetId, resolutionP) {
  if (_peers) {
    //自己先加入房间，因安全帽无法加入用户数为0的房间
    if (roomId && !g_is_meeting) {
      if (getSession('TRANSCRIBE_REAL_VIDEO') === 'true') {
        let req = await bindCamera(roomId)
        console.log(req, '入用户数为0的房间')
        await _joinRoom(roomId, req)
      } else {
        await _joinRoom(roomId)
      }
    }

    // action为0是加入安全帽
    var sendMsg = {
      action: ACION_REQUEST.JION_ROOM,
      content: {
        g_meet_id: roomId,
        g_meet_pwd: null,
        resolution: resolutionP,
        // 0=关闭声音，1=打开声音n
        volume: VOLUME_ON,
      },
    }
    CHAT.chat(websocketapp.HELMET_OPERATION, helmetId, sendMsg)
  }
}

/**
 * 切换视频分辨率
 * @param {*} helmetId 安全帽序列号
 * @param {*} resolutionP 清晰度
 */
async function changeResolutionP(helmetId, resolutionP) {
  if (_peers) {
    current.resolutionP = resolutionP
    // action为2，通知安全帽切换分辨率，resolution代表流畅度
    var sendMsg = {
      action: ACION_REQUEST.SWITCH_RESOLUTION,
      content: {
        resolution: resolutionP,
      },
    }
    CHAT.chat(websocketapp.HELMET_OPERATION, helmetId, sendMsg)
  }
}

// 即将离开当前页面(刷新或关闭)
window.onbeforeunload = window.onpagehide = function() {
  helmetExitMeet(current.helmetId)
  leaveRoomSelf()
  document.getElementById('mvcpVideo').srcObject = null
}

/**
 * 通知安全帽退出房间
 * @param {*} exitHelmetId 退出安全帽id
 */
function helmetExitMeet(exitHelmetId) {
  store.commit('handleIsLocalStreamPublish', false)
  //记录近一次关闭安全帽实时视频的时间
  closeTime = new Date()
  //记录近一次关闭安全帽实时视频的时间
  var sendMsg = {
    action: ACION_REQUEST.EXIT_ROOM,
    content: {
      webPeerId: _peerId,
    },
  }

  CHAT.chat(websocketapp.HELMET_OPERATION, exitHelmetId, sendMsg)
  _consumers.forEach(function(consu) {
    consu.close()
  })
  _consumers.clear()
  consumeredProduIds.clear()
  _micProducer = null
  showVoice = true
}

/**
 * 实时视频操作响应处理，需结合具体业务调整
 * @param {Object} params 接收响应params参数
 */
async function handleHelmetOperationResponse(params) {
  //{"action":0,"ihVersion":"21","isAgoraSpeech":false,"isAudioRecord":false,"isFaceScan":false,"isQRScan":false,"isRecord":false,
  // "isRecordVoiceOpen":true,"isSwitchUser":false,"isWebRtcConnect":false,"netWorkState":1,"roomId":0}
  if (params.helmetId !== current.helmetId) {
    // 当收到别的安全帽的信息时不进行任何处理
    return
  }
  var status = JSON.parse(params.status)
  // console.log(status, 'status')
  console.log('status.stopEventType', status.stopEventType, !status.stopEventType)
  if (status.action === 2) {
    console.log('安全帽加入房间结果：' + status.enterResult)
    if (store.state.helpVideo) {
      unmuteMic()
      localMdiasoupUnmuteMic()
    }
    store.commit('handleIsLocalStreamPublish', true)
    clearTimeout(closeJoinMeet)
    if (!status.enterResult) {
      alertWin(current.userName + i18n.t('videoConnectionFailed'), handleHelmetLeave)
    }
    return
  }
  if (status.action === 1) {
    console.log(`拍照状态:${status.camera}`)
    return
  }
  if (status.action === 0) {
    if (status.groupActual) {
      meetLiveCode = status.groupActual
    }
  }
  // 如果头盔已经在会议中，则直接加入会议
  if (
    status.roomId &&
    !status.stopEventType &&
    document.getElementById('mvcpVideo') &&
    document.getElementById('mvcpVideo').srcObject == null
  ) {
    store.commit('handleIsLocalStreamPublish', true)
    console.log(roomId, status.roomId, '在会议中')
    clearTimeout(closeJoinMeet)
    if (_sendTransport) {
      _sendTransport.close()
    }
    // 因头盔返回的roomId为数字，需要转成字符
    await leaveRoomSelf(status.roomId)
    //防止关闭新的_sendTransport
    is_leave = true
    roomId = '' + status.roomId

    enterRoom = true

    await _joinRoom(roomId, rtmpUrl)
    // 创建媒体消费者
    await getRoomPeers()
  }
  if (status.isFaceScan) {
    warning(current.userName + i18n.t('FaceRecognitionProgress'))
    return
  }
  if (status.isQRScan) {
    warning(current.userName + i18n.t('helmetScanningQR'))
    return
  }
  if (status.isSwitchUser) {
    warning(current.userName + i18n.t('SwitchingUsers'))
    return
  }
  if (status.isAgoraSpeech) {
    warning(current.userName + i18n.t('MicrophoneOccupied'))
    return
  }
  if (status.isRecord) {
    confirmWin(
      current.userName + i18n.t('RecordingPreemptOrNot'),
      () => {
        // 点击确定，抢占录像
        grabRecord(params.helmetId)
      },
      () => {
        // 点击取消事件 关闭直播框
        handleHelmetLeave()
      }
    )
    return
  }
  // console.log('其他',status.resolution,current.resolutionP,params.helmetId,current.helmetId)
  if (
    status.resolution &&
    status.resolution !== current.resolutionP &&
    params.helmetId === current.helmetId &&
    !params.liveUrl
  ) {
    resolvingPower(status.resolution)
    store.commit('handleresolutionP', status.resolution)
    current.resolutionP = status.resolution
    warning(i18n.t('modifiedResolution'))
  }
}

/**
 * 抢占视频
 */
function grabRecord(helmetId) {
  var sendMsg = {
    action: 4,
    content: {
      g_meet_id: roomId,
      g_meet_pwd: null,
      resolution: current.resolutionP,
      volume: VOLUME_ON,
    },
  }
  CHAT.chat(websocketapp.HELMET_OPERATION, helmetId, sendMsg)
}

export { VOLUME_OFF, VOLUME_ON }

export {
  setHandleHelmetOperationResponse,
  setHandleHelmetLeave,
  handleHelmetOperationResponse,
  helmetJoinMeet,
  grabRecord,
  helmetExitMeet,
  changeResolutionP,
  muteMic,
  unmuteMic,
  leaveRoomSelf,
  loginMVCPUtil,
  loginClose,
  setresolvingPower,
  refleshJoin,
  localMiasoupMuteMic,
  localMdiasoupUnmuteMic,
}
